/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/mastercard'
export default icon
